import { render, staticRenderFns } from "./DynamicAllocationType.vue?vue&type=template&id=11142d78"
import script from "./DynamicAllocationType.vue?vue&type=script&lang=js"
export * from "./DynamicAllocationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11142d78')) {
      api.createRecord('11142d78', component.options)
    } else {
      api.reload('11142d78', component.options)
    }
    module.hot.accept("./DynamicAllocationType.vue?vue&type=template&id=11142d78", function () {
      api.rerender('11142d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/DynamicAllocationType.vue"
export default component.exports